import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import {
  crdeitDrawCellDetail,
  excelHeaderColumn,
  excelHeaderCreditSummaryReport,
  excelHeaderCreditSummaryReport1,
  lrDetailPdfFooter,
  pdfCreditSummaryReport,
} from './common/AcountingConstants'
import { focusElemnt, navigation3 } from '../../common/helper'
import * as id from './common/AcountingId'

const TableViewCreditSummary = ({ loginData, tableData, fromDate, toDate, company, StateName, city, branch, updateScreen }) => {
  // console.log('tableData', tableData)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  let openingBalance = tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.ClosingBalance : 0
  let netbooking =
    tableData?.Table?.length > 0
      ? tableData?.Table[0]?.collection -
      tableData?.Table[0]?.cartage +
      tableData?.Table[0]?.demurrage -
      tableData?.Table[0]?.commission -
      tableData?.Table[0]?.incmg_commission
      : 0
  let netReceivable1 = tableData?.Table?.length > 0 ? tableData?.Table[0]?.incoming_topay - tableData?.Table[0]?.outgoing_topay : 0
  // let netReceivable2 = tableData?.Table?.length > 0 ? tableData?.Table[0]?.debitnote+tableData?.Table[0]?.BalanceOut+tableData?.Table[0]?.FailedTransPenalty+tableData?.Table[0]?.LRPenalty - tableData?.Table[0]?.creditnote : 0-tableData?.Table[0]?.BalanceIn
  let netReceivable2 = tableData?.Table?.length > 0
    ? tableData?.Table[0]?.debitnote
    + tableData?.Table[0]?.BalanceOut
    + tableData?.Table[0]?.FailedTransPenalty
    + tableData?.Table[0]?.LRPenalty
    - tableData?.Table[0]?.creditnote
    - tableData?.Table[0]?.BalanceIn
    : 0;

  let PaymentReceived = tableData?.Table?.length > 0 ? tableData?.Table[0]?.pymt_rcvd : 0
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = pdfCreditSummaryReport.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = excelHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const HeaderData = [
      {
        company: company,
        state: StateName,
        city: city,
        branch: branch,
      },
    ]
    // bodyData for credit Summary report
    const bodyData = [
      {
        Head: 'Opening Balance (A)',
        TransactionType: 'A = G (Closing of Prev. Day)',
        TransactionAmount: '',
        TotalAmount: openingBalance,
      },
      {
        Head: '',
        TransactionType: 'Collection (a)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.collection : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Cartage (b)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.cartage : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Demurrage (c)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.demurrage : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Booking Commission (d)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.commission : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Delivery Commission (e)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.incmg_commission : 0,
        TotalAmount: '',
      },
      {
        Head: 'Net Booking (B)',
        TransactionType: 'B = ( a - b + c - d - e )',
        TransactionAmount: '',
        TotalAmount: netbooking,
      },
      {
        Head: '',
        TransactionType: 'Add: Incoming ToPay (f)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.incoming_topay : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Less: Outgoing ToPay (g)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.outgoing_topay : 0,
        TotalAmount: '',
      },
      {
        Head: 'Net Receivable (C)',
        TransactionType: 'C = ( f - g )',
        TransactionAmount: '',
        TotalAmount: netReceivable1,
      },
      {
        Head: '',
        TransactionType: 'Debit Note (h)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.debitnote : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Balance Out (h1)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.BalanceOut : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Failed Transaction Penalty (h2)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.FailedTransPenalty : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Refund LR Penalty (h3)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.LRPenalty : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Credit Note (i)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.creditnote : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Balance In (i1)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.BalanceIn : 0,
        TotalAmount: '',
      },
      {
        Head: 'Net Collectable (D)',
        TransactionType: 'D = ( h+h1+h2+h3-i-i1 )',
        TransactionAmount: '',
        TotalAmount: netReceivable2,
      },
      {
        Head: 'Payment Received (E)',
        TransactionType: 'E = Amt. Recd.',
        TransactionAmount: '',
        TotalAmount: PaymentReceived,
      },
      {
        Head: 'Final Amount (F)',
        TransactionType: 'F = ( A + B + C + D - E )',
        TransactionAmount: '',
        TotalAmount: (openingBalance + netbooking + netReceivable1 + netReceivable2 - PaymentReceived)?.toFixed(2),
      },
      {
        Head: '',
        TransactionType: 'On-Account Collection (j)',
        TransactionAmount: '',
        TotalAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.onacc_bkg : 0,
      },
      {
        Head: 'Closing Balance (G)',
        TransactionType: 'G = F (j)',
        TransactionAmount: '',
        TotalAmount: tableData?.Table2?.length > 0 ? tableData?.Table2[0]?.ClosingBalance : 0,
      },
      {
        Head: '',
        TransactionType: '',
        TransactionAmount: 'Credit Limit',
        TotalAmount: tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.BranchCreditLimit : 0,
      },
      {
        Head: '',
        TransactionType: '',
        TransactionAmount: 'Usable Balance',
        TotalAmount: Number(tableData?.Table2?.length > 0 ? tableData?.Table2[0]?.ClosingBalance : 0) - Number(tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.BranchCreditLimit : 0),
      },
    ]

    const doc = new jsPDF({ orientation: 'P', format: [1080, 1528], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Credit Limit Summary Reports.pdf`,
      subject: 'Credit Limit Summary Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(
          `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
          data.settings.margin.left,
          150
        )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: bodyData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        1: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        2: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        3: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      didParseCell: (data) => {
        crdeitDrawCellDetail(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Credit Limit Summary Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Credit Limit Summary Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Credit Limit Summary Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Credit Limit Summary Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = () => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              {/* {index + 1} */}
              Opening Balance (A)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              A = G (Closing of Prev. Day)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {openingBalance}
              {/* {tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.ClosingBalance : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Collection (a)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.collection : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Cartage (b)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.cartage : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top', borderBottom: 'none' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Demurrage (c)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.demurrage : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Booking Commission (d)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.commission : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Delivery Commission (e)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.incmg_commission : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Booking (B)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              B = ( a - b + c - d - e )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netbooking}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Add: Incoming ToPay (f)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.incoming_topay : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Less: Outgoing ToPay (g)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.outgoing_topay : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Receivable (C)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              C = ( f - g )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netReceivable1}
              {/* {tableData?.Table?.length > 0 ? tableData?.Table[0]?.incoming_topay - tableData?.Table[0]?.outgoing_topay : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Debit Note (h)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.debitnote : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Balance Out (h1)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BalanceOut : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Failed Transaction Penalty (h2)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.FailedTransPenalty : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Refund LR Penalty (h3)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.LRPenalty : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Credit Note (i)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.creditnote : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Balance In (i1)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BalanceIn : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Collectable (D)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              D = ( h+h1+h2+h3-i-i1 )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netReceivable2}
              {/* {tableData?.Table?.length > 0 ? tableData?.Table[0]?.debitnote - tableData?.Table[0]?.creditnote : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Payment Received (E)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              E = Amt. Recd.
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {PaymentReceived}
              {/* {tableData?.Table?.length > 0 ? tableData?.Table[0]?.pymt_rcvd : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Final Amount (F)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              F = ( A + B + C + D - E )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {(openingBalance + netbooking + netReceivable1 + netReceivable2 - PaymentReceived)?.toFixed(2)}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              On-Account Collection (j)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.onacc_bkg : 0}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Closing Balance (G)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              G = F - (j)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table2?.length > 0 ? tableData?.Table2[0]?.ClosingBalance : 0}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              {/* Closing Balance (G) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {/* G = F - (j) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >Credit Limit</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.BranchCreditLimit : 0}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              {/* Closing Balance (G) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {/* G = F - (j) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >Usable Balance</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {Number(tableData?.Table2?.length > 0 ? tableData?.Table2[0]?.ClosingBalance : 0) - Number(tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.BranchCreditLimit : 0)}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  const InsideRowContentForExcel = () => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              {/* {index + 1} */}
              Opening Balance (A)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              A = G (Closing of Prev. Day)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {openingBalance}
              {/* {tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.ClosingBalance : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Collection (a)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.collection : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Cartage (b)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.cartage : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top', borderBottom: 'none' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Demurrage (c)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.demurrage : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Booking Commission (d)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.commission : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Delivery Commission (e)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.incmg_commission : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Booking (B)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              B = ( a - b + c - d - e )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {/* {tableData?.Table?.length > 0
                ? tableData?.Table[0]?.collection -
                  tableData?.Table[0]?.cartage +
                  tableData?.Table[0]?.demurrage -
                  tableData?.Table[0]?.commission -
                  tableData?.Table[0]?.incmg_commission
                : 0} */}
              {netbooking}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Add: Incoming ToPay (f)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.incoming_topay : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Less: Outgoing ToPay (g)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.outgoing_topay : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Receivable (C)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              C = ( f - g )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netReceivable1}
              {/* {tableData?.Table?.length > 0 ? tableData?.Table[0]?.incoming_topay - tableData?.Table[0]?.outgoing_topay : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Debit Note (h)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.debitnote : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Balance Out (h1)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BalanceOut : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Failed Transaction Penalty (h2)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.FailedTransPenalty : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Refund LR Penalty (h3)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.LRPenalty : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Credit Note (i)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.creditnote : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'lerightft', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Balance In (i1)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BalanceIn : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Collectable (D)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              D = ( h+h1+h2+h3-i-i1 )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netReceivable2}
              {/* {tableData?.Table?.length > 0 ? tableData?.Table[0]?.debitnote - tableData?.Table[0]?.creditnote : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Payment Received (E)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              E = Amt. Recd.
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {PaymentReceived}
              {/* {tableData?.Table?.length > 0 ? tableData?.Table[0]?.pymt_rcvd : 0} */}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Final Amount (F)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              F = ( A + B + C + D - E )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {(openingBalance + netbooking + netReceivable1 + netReceivable2 - PaymentReceived)?.toFixed(2)}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              On-Account Collection (j)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.onacc_bkg : 0}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Closing Balance (G)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              G = F - (j)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table2?.length > 0 ? tableData?.Table2[0]?.ClosingBalance : 0}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              {/* Closing Balance (G) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {/* G = F - (j) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >Credit Limit</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.BranchCreditLimit : 0}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              {/* Closing Balance (G) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {/* G = F - (j) */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >Usable Balance</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {Number(tableData?.Table2?.length > 0 ? tableData?.Table2[0]?.ClosingBalance : 0) - Number(tableData?.Table1?.length > 0 ? tableData?.Table1[0]?.BranchCreditLimit : 0)}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }

  return (
    <>
      <Box className="userReport" style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px' }}>
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: Credit Limit Summary Report</h3>
        </Box>
        <Box
          className="userReport-buttons"
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '16px',
          }}
        >
          {showTable ? (
            <>
              <Box onKeyDown={(e) => navigation3(e, 'creditSummaryPdfBtn', id.creditSummarySplitButton, () => { })}>
                <ReactHtmlTableToExcel
                  //id="test-table-xls-button"
                  id="creditSummaryExcelBtn"
                  className="userWisereporttemExcelBtn"
                  // className="receiveitemExcelBtn"
                  table="table-to-xls1"
                  filename={`Branch Credit Limit Summary Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  id="creditSummaryPdfBtn"
                  onKeyDown={(e) =>
                    navigation3(e, 'creditSummaryPrintBtn', 'creditSummaryExcelBtn', () => {
                      printClick(true)
                    })
                  }
                  className="userWisereporttembtn"
                  onClick={() => printClick(true)}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  id="creditSummaryPrintBtn"
                  onKeyDown={(e) =>
                    navigation3(e, id.creditSummaryFromDate, 'creditSummaryPdfBtn', () => {
                      printClick(false)
                    })
                  }
                  className="userWisereporttembtn"
                  onClick={() => printClick(false)}
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => (setShowTable(true), updateScreen())}
                  onKeyDown={(e) => navigation3(e, '', id.creditSummarySplitButton, () => { setShowTable(true); focusElemnt(id.creditSummarySplitButton) })}
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {showTable ? (
        <>
          <Stack
            sx={{ marginLeft: 2, marginRight: 2, height: 440, paddingTop: '10px', marginBottom: '16px' }}
            className="changeScrollColor"
          >
            <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)', width: '75%' }}>
              {/* ---------------Table For Excel--------------- */}
              <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={2}>
                      Report For: Credit Limit Summary Report
                    </TableCell>
                    <TableCell className="reportTD" colSpan={3}>
                      Company Name : _Maven Tech Services Pvt. Ltd.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderCreditSummaryReport1?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderCreditSummaryReport?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{company}</span>
                    </TableCell>
                    {/* <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell> */}
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{StateName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{city}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{branch}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow
                    style={{
                      verticalAlign: 'top',
                    }}
                  >
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Head
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Type
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Amount
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Total Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                {/* {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={15}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? ( */}
                <TableBody
                  className="filter-data-row"
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  <InsideRowContentForExcel />
                </TableBody>
                {/*  ) : (  ''  )} */}
              </Table>
              <Table id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#bfe1ff',
                        color: '#444',
                        position: 'sticky',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        borderBottom: 'none',
                      }}
                      colSpan={15}
                    >
                      Credit Limit Summary Report
                    </TableCell>
                  </TableRow>
                  <TableRow
                    style={{
                      backgroundColor: '#e5f3ff',
                      verticalAlign: 'top',
                    }}
                  >
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Head
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Type
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Amount
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Total Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                {/* {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={15}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? ( */}
                <TableBody
                  className="filter-data-row"
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  <InsideRowContent />
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="creditLimitTransReport"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              style={{ marginTop: '10px' }}
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default TableViewCreditSummary
